import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const DynamicTitle = () => {
    const { profileData } = useSelector((state) => state.auth);

    useEffect(() => {
        // Update document title based on company name
        const companyName = profileData?.compName;
        if (companyName) {
            document.title = `${companyName} `;
        } else {
            // for company name if not found then show ALTepos Admin
            document.title = '';
        }

    }, [profileData?.compName]);

    return null; // This component doesn't render anything
};

export default DynamicTitle;
